<template>
  <el-button size="small" @click="handleSelect" link type="primary"
    >选择</el-button
  >
  <svg-icon :iconClass="props.modelValue" @click="handleSelect"></svg-icon>
  <el-dialog v-model="state.dialogVisible" title="图标">
    <el-scrollbar style="height: 500px">
      <div class="icon-container">
        <div
          class="icon-item"
          :class="state.icon === item ? 'active' : ''"
          v-for="item in state.iconList"
          :key="item"
          @click="handleClick(item)"
        >
          <svg-icon :iconClass="item"></svg-icon>
        </div>
      </div>
    </el-scrollbar>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="state.dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit"> 确定 </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  defineProps,
  onMounted,
  getCurrentInstance,
  reactive,
  ref,
  defineEmits,
  watch,
} from "vue";
const emit = defineEmits();
const { proxy } = getCurrentInstance();
const props = defineProps({
  /** v-model选中项绑定值 */
  modelValue: {
    type: String,
    default: null,
  },
});
const state = reactive({
  dialogVisible: false,
  iconList: [
    "fengxianguankong",
    "gongzuoguanli",
    "danganguanli",
    "caiwuguanli",
    "zuzhijiagou",
    "shouye",
    "shujushangbao",
    "beidouguanli",
    "anquanbaozhang",
    "yinhuanguankong",
    "anquanguanli",
    "xuexiguanli",
    "xitongguanli",
    "anquanjiancha",
    "cheliangxinxi",
    "fengxianxinxi",
    "beidouxinxi",
    "jifenshangcheng",
    "qiyexinxi",
    "renyuanxinxi",
    "shujushangbao1",
    "shujutongji",
    "xitongjiankong",
    "xuexixinxi",
    "yinhuanxinxi",
    "zhiduxinxi",
    "kufangguanli",
    "gongchengguanli-",
    "yingxiaoguanli",
    "xitong",
    "yusuanguanli",
    "guanwangtu",
    "xitong-",
  ],
  icon: "",
});

watch(
  () => props.modelValue,
  (n) => {
    state.icon = n;
  }
);

onMounted(() => {
  console.log(proxy.$attrs);
  state.icon = JSON.parse(JSON.stringify(props.modelValue));
});
/*点击输入框*/
const handleSelect = () => {
  state.dialogVisible = true;
};
/*点击图标*/
const handleClick = (item) => {
  state.icon = item;
};
/*点击确认*/
const handleSubmit = () => {
  emit("update:modelValue", state.icon);
  state.dialogVisible = false;
};
</script>
<style lang="less" scoped>
.icon-container {
  .icon-item {
    display: inline-block;
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    margin-bottom: 10px;
    border: 1px solid #dcdfe6;
    margin-right: 5px;
    font-size: 30px;
    &.active {
      background: #d9d9d9;
    }
  }
}
</style>
